<!-- 互动卡片组件库 -->
<template>
  <div class="interaction-card-container">
    <div v-if="!isShow" :class="{ mask: !isShow }">已隐藏</div>
    <!-- 组件库左侧名称 -->
    <slot name="name" />
    <!-- 使用 Vant Grid 组件布局 -->
    <section  @click="handleClickComponent">
      <van-grid
        v-if="datas.moduleType == 1 || datas.moduleType == 3"
        :border="false"
        :column-num="datas.moduleType == 1 ? 2 : 1"
      >
        <van-grid-item v-for="(item, index) in datas.imageList" :key="index">
          <div
            class="interaction-card-wrapper"
            :style="{
              backgroundColor: datas.backgroundColor,
            }"
          >
            <div>
              <van-image
                width="100%"
                height="100%"
                src="https://img01.yzcdn.cn/vant/cat.jpeg"
              />
            </div>
            <div class="interaction-card-content">
              <div class="card-content">
                <h5
                  class="interaction-card-title"
                  :style="{
                    color: datas.textColor,
                  }"
                >
                  {{ item.text }}
                </h5>
                <h6
                  :style="{
                    color: datas.subTextColor,
                  }"
                >
                  {{ item.subText }}
                </h6>
              </div>
              <div class="button-container flex-between">
                <h6
                  :style="{
                    color: datas.subTextColor,
                  }"
                >
                  {{ item.wordText }}
                </h6>
                <van-button
                  style="background-color: var(--theme-primary); padding: 0 5px"
                  type="info"
                  size="mini"
                  :style="{
                    borderRadius: `${datas.buttonRadius}px`,
                  }"
                >
                  <span style="padding: 0 10px">
                    {{ item.buttonText }}
                  </span>
                </van-button>
              </div>
            </div>
          </div>
        </van-grid-item>
      </van-grid>
      <div v-else>
        <van-grid direction="horizontal" :column-num="1">
          <van-grid-item v-for="(item, index) in datas.imageList" :key="index">
            <div
              class="interaction-card-wrapper horizontal"
              :style="{
                backgroundColor: datas.backgroundColor,
              }"
            >
              <van-image
                class="horizontal"
                width="50%"
                height="50%"
                src="https://img01.yzcdn.cn/vant/cat.jpeg"
              />
              <div class="interaction-card-content horizontal">
                <div class="card-content">
                  <h5
                    class="interaction-card-title"
                    :style="{
                      color: datas.textColor,
                    }"
                  >
                    {{ item.text }}
                  </h5>
                  <h6
                    :style="{
                      color: datas.subTextColor,
                    }"
                  >
                    {{ item.subText }}
                  </h6>
                </div>
                <div class="button-container flex-between">
                  <h6
                    :style="{
                      color: datas.subTextColor,
                    }"
                  >
                    {{ item.wordText }}
                  </h6>
                  <van-button
                    style="
                      background-color: var(--theme-primary);
                      padding: 0 5px;
                    "
                    type="info"
                    size="mini"
                    :style="{
                      borderRadius: `${datas.buttonRadius}px`,
                    }"
                  >
                    <span style="padding: 0 10px">
                      {{ item.buttonText }}
                    </span>
                  </van-button>
                </div>
              </div>
            </div>
          </van-grid-item>
        </van-grid>
      </div>
    </section>
    <!-- 删除组件 -->
    <slot name="deles" />
  </div>
</template>

<script>
export default {
  name: "interactioncard",
  props: {
    datas: Object,
    isShow: Boolean,
  },
  data() {
    return {};
  },
  created() {
    console.log(
      "servicenavigation子组件挂载了--------------------111-1-1-1-1-1--1",
      this.datas,
    );
  },
  methods: {
    handleClickComponent() {
      console.log(
        "互动卡片列表子组件点击了组件",
        this.datas,
        this.datas.parentComponent,
      );
      this.$emit(
        "handleCallbackComponent",
        {
          customStyle: {},
          handler: "handleClickComponent",
          icon: "",
          id: this.datas.parentComponent,
          outline: true,
          ref: `${this.datas.parentComponent}style`,
          text: this.datas.text,
          type: "childrenComponent",
        },
        this.datas,
      );
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep.van-image.horizontal {
  .van-image__img {
    border-radius: 10px !important;
  }
}
::v-deep.van-image {
  .van-image__img {
    border-radius: 10px 10px 0 0 !important;
  }
}
::v-deep.van-grid {
  .van-grid-item {
    .van-grid-item__content {
      padding: 0px 3px !important;
    }
  }
}
// 外层容器保留原有宽度和盒模型设置
.interaction-card-container {
  width: 100%;
  box-sizing: border-box;
  padding: 3px 5px;
  .interaction-card-wrapper.horizontal {
    display: flex;
    margin-bottom: 5px;
  }
  .interaction-card-wrapper {
    border-radius: 10px;
    margin-bottom: 5px;
    .interaction-card-content.horizontal {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding: 5px;
    }
    .interaction-card-content {
      width: 100%;
      box-sizing: border-box;
      padding: 0 5px 5px 5px;
    }
    .card-content {
      .interaction-card-title {
        margin: 0 0 8px 0;
      }
    }
    .button-container {
    }
  }
}
</style>
